// extracted by mini-css-extract-plugin
module.exports = {"screenLoader":"screenLoader_screenLoader__3Cgtp"};